import React from 'react';
import flyer1 from '../assets/Square Beauty Web 1.png';
import flyer2 from '../assets/Square Beauty Web 2.png';
import flyer2b from '../assets/Square Beauty Web 2b.png';
import flyer3a from '../assets/Square Beauty Web 3a.png';
import flyer3b from '../assets/Square Beauty Web 3b.png';
import flyer3c from '../assets/Square Beauty Web 3c.png';

const SquareBeauty = () => {
  return (
    <div className='w-[100vw]  flex flex-col items-center justify-center '>
      <div className='flex items-center md:flex-row flex-col md:h-screen '>
        <img src={flyer1} alt='Flyer 1' className='h-screen ' />
        <img src={flyer3a} alt='Flyer 3' className='h-screen md:mt-0 -mt-8' />
        <img src={flyer3b} alt='Flyer 3' className='h-screen md:mt-0 -mt-8' />
      </div>
      <div className='flex md:flex-row flex-col items-center justify-center w-full h-full'>
        <img src={flyer3c} alt='Flyer 3' className='h-screen md:mt-0 -mt-24' />
        <img src={flyer2} alt='Flyer 1' className='h-screen md:mt-0 -mt-12 ' />
        <div className='relative flex flex-col justify-center md:mt-0 -mt-8'>
          <img src={flyer2b} alt='Flyer 2' className='h-screen' />
          <div className='h-[15vh] w-full absolute mt-[45vh] flex flex-col gap-6 items-center justify-center'>
            <h3 className='text-gray-700 text-2xl font-bold'>
              Ready to take the next step?
            </h3>
            <a
              href='https://squareup.com/i/F1E3093FE0'
              target='_blank'
              rel='noreferrer'
            >
              <button className='bg-[#cc1b17] text-white px-12 py-4 rounded-2xl'>
                SIGN UP
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SquareBeauty;
